<edp-banner-app *ngIf="showAppBanner"></edp-banner-app>
<edp-rating *ngIf="isApp && (ratingStatus$ | async).showRating"></edp-rating>
<edp-modal-iframe *ngIf="iframeModal$ | async as iframeModal" [params]="iframeModal"></edp-modal-iframe>
<router-outlet></router-outlet>
<edp-loader *ngIf="(loader$ | async)" [position]="'full'"></edp-loader>
<ngx-guided-tour></ngx-guided-tour>